import { render, staticRenderFns } from "./confirm-save-changes-modal.vue?vue&type=template&id=49e5baef"
import script from "./confirm-save-changes-modal.vue?vue&type=script&lang=js"
export * from "./confirm-save-changes-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports